import {
  Button,
  Typography,
  Stack
} from '@mui/material';
import { BackgroundImage, Container} from '../../components';
import { aboutUs as ReviewUsAssets } from '../../assets';
import { useNavigate,useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async'; // Import Helmet

export const ReviewUs = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Get current location

  // Construct the full URL based on current location
  const currentUrl = `https://www.bluesagepools.com${location.pathname}`;

  return (
    <>
      <Helmet>
        <title>Review Us Blue Sage Pools - Pool Services & Maintenance in DFW</title>
        <meta
          name="description"
          content="Blue Sage Pools has over 55 years of combined experience providing pool services, maintenance, and construction in DFW and Texas. Contact us today!"
        />
        <meta name="author" content="Blue Sage Pools" />
        <meta property="og:title" content="Review Us Blue Sage Pools - Pool Services & Maintenance" />
        <meta
          property="og:description"
          content="With over 55 years of experience, Blue Sage Pools provides expert pool maintenance, repair, and construction services across DFW and Texas."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.bluesagepools.com/review-us" />
        <meta property="og:image" content={ReviewUsAssets.blueSagePoolLogo} />
        {/* Canonical URL to avoid duplicate content issues */}
        <link rel="canonical" href={currentUrl} />
      </Helmet>

      <Button
        variant="contained"
        onClick={() => navigate('/schedule-now')}
        sx={{
          p: 1.5,
          position: 'fixed',
          zIndex: '9999',
          borderTopRightRadius: 0,
          borderTopLeftRadius: 0,
          top: '70%',
          transformOrigin: 'left top',
          rotate: '270deg'
        }}
      >
        Schedule Now
      </Button>
      <BackgroundImage
        sx={{ height: '45vh' }}
        src={ReviewUsAssets.blueSagePoolCover}
        alt="Blue Sage Pools"
      />

	  
<Container sx={{ my: { xs: 5, sm: 10, md: 15 }, textAlign: 'justify' }}>
	  <Typography variant="caption">Review Us!</Typography>
            <Typography sx={{ my: 4 }} variant="h3">
              How Did We Do?
            </Typography>
            
            <Typography variant="paragraph">
              Your feedback is important to our team. 
            </Typography>
            <Typography variant="paragraph">
             If you can take a moment to leave us a review we would greatly appreciate your time!
            </Typography>
	  
	  <Stack
            direction="row"
            flexWrap="wrap"
            gap={2}
            justifyContent="space-evenly"
            alignItems="center"
            sx={{ my: { xs: 2, sm: 3, md: 4 } }}
          >
	  
	  
	  
	  <Stack spacing={2} alignItems="center">
               <Button
              variant="contained"
              disableElevation
              disableRipple
              sx={{ py: 3, px: 4 ,
                width: '300px'
              }}
              onClick={() =>
                window.open('https://www.google.com/search?q=Blue+SAge+Pools+&sca_esv=fd720482c30bdadb&source=hp&ei=A4rQZ5rsJ4rGkPIP-4jTuQ0&iflsig=ACkRmUkAAAAAZ9CYE1lU_GEfwJ2xqe2r1L7Ga7KutGh2&ved=0ahUKEwja-bjv3IKMAxUKI0QIHXvENNcQ4dUDCBg&uact=5&oq=Blue+SAge+Pools+&gs_lp=Egdnd3Mtd2l6IhBCbHVlIFNBZ2UgUG9vbHMgMgYQABgWGB4yCxAAGIAEGIYDGIoFMgsQABiABBiGAxiKBTILEAAYgAQYhgMYigUyCBAAGIAEGKIEMggQABiABBiiBDIIEAAYgAQYogRIu0dQ2wVYp0VwAXgAkAEAmAH4AaAB2hmqAQUwLjguOLgBA8gBAPgBAZgCEKAC0xqoAgDCAgUQLhiABMICCxAuGIAEGNEDGMcBwgIFEAAYgATCAhQQLhiABBjHARiYBRiaBRieBRivAcICFBAuGIAEGMcBGJgFGJkFGJ4FGK8BwgIIEC4YgAQY1ALCAgsQLhiABBjHARivAcICDRAuGIAEGNEDGMcBGArCAggQABgWGAoYHsICCBAAGKIEGIkFmAME8QWsErYYBl6F25IHBjAuNC4xMqAHusQB&sclient=gws-wiz#lrd=0x2d5a61d0b9cc3cbb:0x908159ed30f1588e,3', '_blank')
              }
            >
              GOOD
            </Button>
            </Stack>
			
			 <Stack spacing={2} alignItems="center">
               <Button
              variant="contained"
              disableElevation
              disableRipple
              sx={{ py: 3, px: 4 ,
                width: '300px' }}
              onClick={() =>
                window.open('mailto:info@BlueSagePools.com', '_self')
              }
            >
              NOT SO GOOD
            </Button>
            </Stack>	  
	   </Stack>  
	  
	   </Container>
	  
	  
	  
    </>
  );
};
